import { Button, makeStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { RESERVED_TAGS } from '../../../constants/constants';
import { ReactComponent as DeleteButtonSvg } from '../../../images/delete-btn-light.svg';
import { ReactComponent as PlayButtonSvg } from '../../../images/play-btn.svg';
import { ReactComponent as ShareButtonSvg } from '../../../images/share-btn.svg';
import thumbsDownImg from '../../../images/thumbs-down-grey.png';
import thumbsUpImg from '../../../images/thumbs-up-grey.png';
import { isAITag, isRetrievalTag } from '../../../utils/tagValidatorUtils';
import { splitName } from '../../../utils/utils';
import RetrievalFeedback from '../../flags/components/RetrievalFeedback';
import { initializePollyProcess } from '../../flags/components/pollyProcess';
import '../styles/pdfViewer.css';

const useStyles = makeStyles((theme) => ({
  button: {
    '&.MuiButton-root:hover': {
      backgroundColor: 'transparent' // Set padding to 0 for the button label
    }
  }
}));

const Carousel = ({
  data,
  instance,
  onClose,
  handleFlagPlay,
  handleConfirmationDeleteOpen,
  handleShareModalInit,
  isPersonalPodcast
}) => {
  const classes = useStyles();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [show, setShow] = useState(null);
  const [open, setOpen] = useState(false);

  const handleShowActions = (e) => {
    setShow(e.currentTarget);
    setOpen((prevState) => setOpen(!prevState));
  };

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % data?.flagsList.length);
  };

  const prevSlide = () => {
    setCurrentIndex(
      (prevIndex) =>
        (prevIndex - 1 + data?.flagsList.length) % data?.flagsList.length
    );
  };

  const handleClose = () => {
    onClose();
    setCurrentIndex(0);
  };

  const goToSlide = (num) => {
    setCurrentIndex(num);
  };

  const handleShareBtnAction = (e) => {
    handleShareModalInit(e, data?.flagsList[currentIndex]);
  };

  const handlePlayBtnAction = async (e) => {
    const flagsToPlay = [data?.flagsList[currentIndex]];
    initializePollyProcess(e, flagsToPlay, false, handleFlagPlay);
  };

  const renderComment = (flag) => {
    const hasComment = flag?.dictation && flag?.dictation !== '';
    if (hasComment) {
      if (isRetrievalTag(flag?.tag)) {
        return (
          <RetrievalFeedback
            tag={flag?.tag}
            dictation={flag?.dictation}
            source="highlightPopup"
          />
        );
      }
      return <p className="comment">{`Comment: ${flag?.dictation}`}</p>;
    }
    return <p className="comment">Comment: No comment yet</p>;
  };

  const renderTag = (flag) => {
    if (
      flag.isShared ||
      flag?.flashflag ||
      flag?.tag === RESERVED_TAGS.UPTAG ||
      flag?.tag === RESERVED_TAGS.DOWNTAG ||
      flag?.tag === '' ||
      isRetrievalTag(flag?.tag)
    ) {
      return <></>;
    }

    return <div className="tag-flag">{flag?.tag}</div>;
  };

  return (
    <div className="pdfviewer-popup-card">
      <div className="pdfviewer-popup-card-top">
        <button className="pdfviewer-popup-close-btn" onClick={handleClose}>
          x
        </button>
      </div>
      {data?.flagsList?.length > 1 && (
        <button
          className="carousel-button carousel-button--prev"
          onClick={prevSlide}
        >
          &lt;
        </button>
      )}
      <div className="carousel">
        <div
          className="carousel-content"
          style={{ transform: `translateX(-${currentIndex * 100}%` }}
        >
          {data?.flagsList?.map((item, index) => (
            <div
              key={index}
              className={`carousel-slide ${
                index === currentIndex ? 'active' : ''
              }`}
            >
              <div className="carousel-slide-wrapper">
                {open && (
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      wordBreak: 'break-all'
                    }}
                  >
                    <div className="actions-popover">
                      {item?.isShared ||
                      (item &&
                        (isAITag(item.tag) ||
                          isPersonalPodcast ||
                          isRetrievalTag(item.tag))) ? (
                        <></>
                      ) : (
                        <Button
                          className={`${classes.button} jsShareBtn `}
                          onClick={handleShareBtnAction}
                        >
                          <ShareButtonSvg
                            fontSize={15}
                            fill="#7d7d7f"
                            width={20}
                            height={20}
                          />
                        </Button>
                      )}
                      <Button
                        className={`${classes.button} jsPlayBtn`}
                        onClick={handlePlayBtnAction}
                      >
                        <PlayButtonSvg
                          fontSize={15}
                          fill="#7d7d7f"
                          width={20}
                          height={20}
                        />
                      </Button>
                      {item &&
                      (isAITag(item.tag) || isRetrievalTag(item.tag)) ? (
                        <></>
                      ) : (
                        <Button
                          className={`${classes.button} jsDeleteBtn`}
                          onClick={() =>
                            handleConfirmationDeleteOpen([
                              data?.flagsList[currentIndex]
                            ])
                          }
                        >
                          <DeleteButtonSvg
                            fontSize={15}
                            stroke="#7d7d7f"
                            fill="none"
                            width={20}
                            height={20}
                          />
                        </Button>
                      )}
                    </div>
                  </div>
                )}
                <div className="carousel-slide-top">
                  <div className="carousel-slide-top-left">
                    <div
                      className="author-box--round"
                      style={{
                        backgroundColor: item?.isMine ? item.color : '#D6D6D6',
                        color: '#fff'
                      }}
                    >
                      {splitName(item?.author)}
                    </div>
                    {/*<span className='author-box' style={{backgroundColor: item?.isMine ? item.color : '#D6D6D6'}} ></span>*/}
                    <span
                      className="author-name"
                      style={{ color: 'rgb(159,173,188)' }}
                    >{`Highlighted by ${item?.author}:`}</span>
                  </div>
                  <div
                    style={{ display: 'flex' }}
                    className="carousel-slide-top-right"
                  >
                    <div
                      className="point-menu"
                      onClick={(e) => handleShowActions(e)}
                    >
                      ...
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <div>
                    {item?.tag === 'UPTAG' ? (
                      <img src={thumbsUpImg} />
                    ) : item?.tag === 'DOWNTAG' ? (
                      <img src={thumbsDownImg} />
                    ) : (
                      <></>
                    )}
                  </div>
                  <div className="carousel-slide-middle">
                    {renderComment(item)}
                    {renderTag(item)}
                  </div>
                </div>
              </div>
              {data?.numOfUpTag > 0 || data?.numOfDownTag > 0 ? (
                <div className="carousel-slide-bottom" style={{}}>
                  <figure>
                    <img
                      src={thumbsUpImg}
                      width="16px"
                      height="16px"
                      alt="thumbs up icon"
                    />
                    <figcaption>{data?.numOfUpTag}</figcaption>
                  </figure>
                  <figure>
                    <img
                      src={thumbsDownImg}
                      width="16px"
                      height="16px"
                      alt="thumbs down icon"
                    />
                    <figcaption>{data?.numOfDownTag}</figcaption>
                  </figure>
                </div>
              ) : (
                <></>
              )}
            </div>
          ))}
        </div>
      </div>
      {data?.flagsList?.length > 1 && (
        <div className="carousel-dot-wrapper">
          {data?.flagsList?.map((item, index) => (
            <span
              key={index}
              data-key={index}
              className={`carousel-dot carousel-dot--${index} ${
                index === currentIndex ? 'active' : ''
              }`}
              onClick={() => goToSlide(index)}
            ></span>
          ))}
        </div>
      )}
      {data?.flagsList?.length > 1 && (
        <button
          className="carousel-button carousel-button--next"
          onClick={nextSlide}
        >
          &gt;
        </button>
      )}
    </div>
  );
};
export default React.memo(Carousel);
